// ----------------------------------------------------------------------
// <copyright file="Izenda.ScheduleBody.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ScheduleBody component
 */
!(function () {

  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var actions = require('./Izenda.ScheduleBodyActions');
  var SubscriptionGrid = require('modules/Subscription/Izenda.SubscriptionGrid');
  var DashboardSchedulingConstants = require('logic/data/Izenda.DashboardSchedulingConstants');
  var Dimensions = require('share/components/hoc/Izenda.Dimensions');
  var ReportDesignerConstants = require('logic/data/Izenda.ReportDesignerConstants');
  var { isNil } = require('lodash/fp');

  var ScheduleBody = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    componentWillMount: function() {
      var subscribedInstancesStore = this.props.subscribedInstancesStore;
      subscribedInstancesStore.model.setType(false);
      subscribedInstancesStore.updateReportId(this.props.store.masterModel.reportId);
    },

    componentDidMount: function () {
      var subscribedInstancesStore = this.props.subscribedInstancesStore;
      if (! isNil(this.props.id)) {
        // Get data for edit case
        subscribedInstancesStore.updateReportId(this.props.store.masterModel.reportId);
      }

      subscribedInstancesStore.loadSchedules(true, this.props.store.masterModel.schedules);
    },

    /**
     * render component
     * @return {Object} component
     */
    render: function () {
      var props = this.props;
      var subscribedInstancesStore = props.subscribedInstancesStore;

      return (
        <SubscriptionGrid reportState={ReportDesignerConstants.REPORT_STATE.DRAFT}
                          store={props.subscribedInstancesStore}
                          pageConstants={DashboardSchedulingConstants}
                          containerWidth={props.width}
                          isPopupMode={false}
                          onSavePopupDesigner={props.onSaveSchedule}
                          onSearch={subscribedInstancesStore.searchSchedules.bind(subscribedInstancesStore)}
                          onDelete={props.onDeleteSchedule}
                          onCopy={props.onCopySchedule} />
      );
    }
  });

  module.exports = connect(actions, Dimensions)(ScheduleBody);
} ());



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Schedule/Izenda.ScheduleBody.jsx